import { useState } from 'react';

function useGuide(animationOrder: string[], customAnimationClass?: string) {
  const [animationQueue, setAnimationQueue] = useState(animationOrder);

  function isCurrentlyAnimated(key: string) {
    if (!animationQueue?.length || animationQueue[0] !== key) {
      return false;
    }
    return true;
  }

  function finishAnimation(key: string) {
    if (!animationQueue?.length || animationQueue?.[0] !== key) {
      return;
    } else {
      const newAnimationQueue = [...animationQueue];
      newAnimationQueue.shift();
      setAnimationQueue(newAnimationQueue);
    }
  }

  function getCurrentAnimationClass(key: string) {
    if (isCurrentlyAnimated(key)) {
      return customAnimationClass ?? 'pulsating-border';
    } else {
      return '';
    }
  }

  return { isCurrentlyAnimated, finishAnimation, getCurrentAnimationClass };
}

export default useGuide;
